import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../../pm-plugins/main';

import { fetchSuggestions } from './api';

/**
 * Fetches the suggestions and updates the plugin state.
 */
export const updateSuggestions = async ({
	api,
	contentAri,
	forceAdf,
	generate,
	signal,
}: {
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined;
	contentAri?: string;
	forceAdf?: boolean;
	generate: boolean;
	signal?: AbortSignal;
}) => {
	if (!api) {
		return;
	}
	/**
	 * If the contentAri is not provided OR
	 * if forceAdf is true, we fetch the suggestions using ADF and update the suggestions.
	 */
	if (!contentAri || forceAdf) {
		const doc = await api?.core?.actions.requestDocumentAsync();
		const suggestions = await fetchSuggestions({
			contentAdf: JSON.stringify(doc),
			contentAri: '',
			generate,
			signal,
		});
		api?.core?.actions?.execute(({ tr }) => {
			tr.setMeta(aiSuggestionsPluginKey, {
				action: 'SET_SUGGESTIONS',
				suggestions,
			});
			return tr;
		});
		return;
	}

	const suggestions = await fetchSuggestions({ contentAri, generate, signal });

	api?.core?.actions?.execute(({ tr }) => {
		tr.setMeta(aiSuggestionsPluginKey, {
			action: 'SET_SUGGESTIONS',
			suggestions,
		});
		return tr;
	});
};
